module.exports = "<div class=\"loader-wrap\">\n    <div class=\"loader-content\">\n        <div class=\"loading\"></div>\n    </div>\n</div>"